import { CSSProperties } from 'react';
import { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive'
import styles from './index.module.scss';

export interface Props {
    children?: ReactNode
    width?: number
    style?: CSSProperties | undefined;
}



// eslint-disable-next-line react/display-name
export default ({ width = 900, style, children }: Props) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })


    const layoutPC = (
        <div className={`page ${styles.page} `} style={style}>
            <div className={styles.left}></div>
            <div className={styles.mid} style={{ width }}>
                {children}
            </div>
            <div className={styles.right}></div>

        </div>
    )

    const layoutMobile = (
        <div className="page">
            {children}
        </div>
    )


    return (
        <>
            { isMobile ? layoutMobile : layoutPC }
        </>
    )
}